module.exports = __webpack_public_path__ + "static/media/Interstate-Regular.8c39633a.woff2";